module.exports = __webpack_public_path__ + "img/00038.b0836079.webp";